function CartDeleteIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={22}
            viewBox="0 0 20 22"
            {...props}
        >
            <path d="M13.525 2.95V.125H6.2V2.95H.1v1.525h1.825l1.3 16.925H16.55l1.3-16.925h2.075V2.95h-6.4zm-1.5-1.325v1.3h-4.3v-1.3h4.3zM4.6 19.85L3.425 4.45H16.3l-1.2 15.4H4.6z" />
            <path d="M9.1 6.65h1.525v11.075H9.1zm4.326 11.121l-1.523-.083.602-11.082 1.522.082zm-7.13 0l-.6-11.084 1.523-.082.6 11.084z" />
        </svg>
    );
}

export default CartDeleteIcon;
